<template>
  <div class="congrats-container">
    <!-- Konfetti w tle -->
    <div class="confetti">
      <div
        class="confetti-piece"
        v-for="i in 50"
        :key="i"
        :style="confettiStyle(i)"
      ></div>
    </div>

    <!-- Treść gratulacji -->
    <div class="congrats-content">
      <h1>Gratulacje!</h1>

      <p class="certificate-text">
        Jesteś oficjalnie
        <strong>Prawdziwym Bohaterem Świątecznego Wyzwania 2025!</strong>
      </p>

      <div class="prize-text">
        <div class="prize-card">
          <h3>Odkrywasz mapę skarbów!</h3>
          <div class="prize-icon">🗺️</div>
          <div class="steps-container">
            <div
              v-for="(step, index) in steps"
              :key="index"
              v-show="index <= currentStep"
              class="step-item"
            >
              <input
                type="checkbox"
                :id="`step-${index}`"
                v-model="step.completed"
                @change="handleStepChange(index)"
              />
              <label :for="`step-${index}`">{{ step.text }}</label>
            </div>
          </div>
        </div>
      </div>
      <p class="farewell">Do zobaczenia za rok!</p>

      <button @click="resetCookies" class="reset-button">
        Zresetuj postęp ✨
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

const steps = ref([
  { text: "Stań centralnie pod lampą", completed: false },
  { text: "Zrób 6 kroków w kierunku NE/E", completed: false },
  { text: "Zrób 5 kroków w kierunku SE", completed: false },
  { text: "Zrób 7 kroków w kierunku NW", completed: false },
  { text: "Zrób 1 krok w kierunku E", completed: false },
  { text: "Skarb jest teraz w zasięgu ręki!", completed: false },
]);

const currentStep = ref(0);

const handleStepChange = (index) => {
  if (steps.value[index].completed) {
    currentStep.value = index + 1;
  }
};

// Generowanie losowych konfetti
const confettiStyle = (i) => {
  const size = Math.random() * 10 + 5;
  const left = Math.random() * 100;
  const background = `hsl(${Math.random() * 60 + 20}, 100%, 50%)`;
  const animationDuration = Math.random() * 3 + 2;
  const delay = Math.random() * 2;

  return {
    width: `${size}px`,
    height: `${size}px`,
    left: `${left}%`,
    background,
    animationDuration: `${animationDuration}s`,
    animationDelay: `${delay}s`,
  };
};

const resetCookies = () => {
  ["puzzle1", "puzzle2", "puzzle3", "puzzle4"].forEach((puzzle) => {
    document.cookie = `${puzzle}=; max-age=0`;
  });
  document.cookie = `Knowledge=; max-age=0`;
  router.push("/home");
};
</script>

<style scoped>
/* Kontener główny */
.congrats-container {
  text-align: center;
  padding: 20px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #f5f7fa, #e0f2f1);
  color: #333;
  font-family: "Roboto", sans-serif;
  position: relative;
  overflow: hidden;
}

/* Konfetti */
.confetti {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.confetti-piece {
  position: absolute;
  border-radius: 50%;
  opacity: 0.8;
  animation: fall linear infinite;
}

@keyframes fall {
  0% {
    transform: translateY(-10px) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(110vh) rotate(360deg);
    opacity: 0;
  }
}

/* Karta z nagrodą */
.congrats-content {
  background: white;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 90%;
  position: relative;
  z-index: 2;
}

h1 {
  font-size: 2em;
  color: #2e7d32;
  margin-bottom: 20px;
}

.prize-card {
  background: linear-gradient(145deg, #fff, #f9f9f9);
  padding: 25px;
  border-radius: 12px;
  margin: 20px auto;
  text-align: center;
}

.prize-icon {
  font-size: 3em;
  margin: 10px 0;
}

.certificate-text {
  font-size: 1.2em;
  color: #2e7d32;
  line-height: 1.5;
}

.farewell {
  font-size: 1.1em;
  color: #555;
  margin-top: 20px;
}

/* Kroki */
.steps-container {
  margin: 20px 0;
  text-align: left;
  max-width: 300px;
  margin-left: auto;
  margin-right: auto;
}

.step-item {
  margin: 10px 0;
  display: flex;
  align-items: center;
}

.step-item input[type="checkbox"] {
  margin-right: 10px;
  cursor: pointer;
}

.step-item label {
  cursor: pointer;
}

/* Przycisk resetowania */
.reset-button {
  background: linear-gradient(135deg, #4caf50, #2e7d32);
  color: white;
  border: none;
  padding: 12px 25px;
  border-radius: 8px;
  font-size: 1em;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  margin-top: 20px;
}

.reset-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}
</style>
